import { ClearIndicatorProps } from 'react-select'
import { CSSProperties } from 'react'
import CrossIcon from '@/public/input-cross.svg'

export const ClearIndicator = (props: ClearIndicatorProps) => {
  const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={{ ...getStyles('clearIndicator', props), cursor: 'pointer' } as CSSProperties}
    >
      <CrossIcon width="1.4em" height="1.4em" />
    </div>
  )
}
